import React, { useState } from 'react'
import styled from 'styled-components'

const Title = styled.p`
  font-size: 8rem;
  color: #fff;
  font-family: 'MongoGrotesqueLight';
  margin: 0 0 2rem 0;
  @media (max-width: 900px) {
    font-size: 5rem;
  }
  @media (max-width: 410px) {
    font-size: 4rem;
  }
`

const PageContainer = styled.div`
  background-color: #000;
  color: #fff;
  min-height: 100vh;
  margin: 4rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (max-width: 900px) {
    margin: 2rem;
    width:90%;
    min-height: auto;
    padding-bottom:4rem;
  }
`

const Item = styled.div`
  width: 100%;
  border-bottom: 1px solid rgba(255,255,255,0.2);
`

const QuestionRow = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 1.5rem 0;
  width: 100%;
`

const QuestionText = styled.p`
  font-size: 1.2rem;
  margin: 0;
  flex: 1;
  @media (max-width: 410px) {
    font-size: 1rem;
  }
`

const ToggleIcon = styled.span`
  font-size: 2rem;
  margin-left: 1rem;
  user-select: none;
`

const Answer = styled.p`
  font-size: 1rem;
  margin: 0 0 1rem 0;
  color: #ddd;
 
`

const AnswerWrapper = styled.div<{ isOpen: boolean }>`
  max-height: ${({ isOpen }) => (isOpen ? '500px' : '0')};
  overflow: hidden;
  transition: max-height 0.6s ease;
`

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null)


  const faqs = [
    {
      question: "1. Combien de Jokers y a-t-il dans le Joker Club ?",
      answer:
        "4444 Jokers répartis en 5 familles (Pique, Coeur, Carreau, Trèfle, Eternal) et 6 niveaux de raretés (Commun, Rare, Épique, Légendaire, Divin, Unique)",
    },
    {
      question: "2. Comment obtenir un NFT Joker Club ?",
      answer:
        "Connexion sur la plateforme de marché secondaire OpenSea : https://opensea.io/fr/collection/jokerclub-1",
    },
    {
      question: "3. Comment rejoindre la communauté Joker Club ?",
      answer:
        "Découvrir les réseaux sociaux officiels sur ce lien: https://linktr.ee/jokerclubspirit",
    },
    {
      question: "4. Comment accéder à mes avantages ?",
      answer:
        "Rendez-vous sur le site du MultiShop et suivez toute l'actualité.",
    },
    {
      question: "5. Comment contacter l'assistance ?",
      answer:
        "Envoyez nous un mail à l'adresse mail suivante : jokerclub@partouche.com",
    },
  ]

 
  const handleClick = (idx: number) => {
    setActiveIndex(prev => (prev === idx ? null : idx))
  }

  return (
    <PageContainer>
    <Title>FOIRE AUX QUESTIONS</Title>

    {faqs.map((faq, idx) => {
      const isOpen = activeIndex === idx
      return (
        <Item key={idx}>
          <QuestionRow onClick={() => handleClick(idx)}>
            <QuestionText>{faq.question}</QuestionText>
            <ToggleIcon>{isOpen ? '–' : '+'}</ToggleIcon>
          </QuestionRow>

          <AnswerWrapper isOpen={isOpen}>
            <Answer>{faq.answer}</Answer>
          </AnswerWrapper>
        </Item>
      )
    })}
  </PageContainer>
)
}

export default Faq
